import axios from "axios";
import { Base_URL } from "../url";

// Save commercial details
export const saveCommercialDetails = async (commercialData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/CommercialMaster/CreateCommercial`,
      commercialData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to save commercial"
    );
  }
};

// Get all commercials (for listing page)
export const getAllCommercials = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/CommercialMaster/GetAllCommercials`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch commercials"
    );
  }
};

// Get commercials by organization
export const getCommercialsByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/CommercialMaster/GetCommercialsByOrg/${orgId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch commercials"
    );
  }
};

// Get commercial by ID
export const getCommercialById = async (commercialId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/CommercialMaster/GetCommercialById/${commercialId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch commercial"
    );
  }
};

// Update commercial
export const updateCommercial = async (commercialId, commercialData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/CommercialMaster/UpdateCommercial/${commercialId}`,
      commercialData
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update commercial"
    );
  }
};

// Get commercials by project ID
export const getCommercialsByProject = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/CommercialMaster/GetCommercialsByProject/${projectId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch commercials for project"
    );
  }
};

// Export commercials to Excel
export const exportCommercialsToExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/CommercialMaster/ExportCommercialsToExcel`,
      {},
      {
        responseType: "blob", // Important for file download
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to export commercials"
    );
  }
};
